
export const ADD_ACTIVITY_BANNER_ACTION = 'ADD_ACTIVITY_BANNER_ACTION';
export const DELETE_ACTIVITY_BANNER_ACTION = 'DELETE_ACTIVITY_BANNER_ACTION';
export const DELETE_ALL_ACTIVITY_BANNER_ACTION = 'DELETE_ALL_ACTIVITY_BANNER_ACTION';
export const UPDATE_ACTIVITY_BANNER_ACTION = 'UPDATE_ACTIVITY_BANNER_ACTION';